import { z } from "zod";

import { DocumentResponseSchema } from "./responses";

/**
 * Google Drive connection operations
 * Includes: Auth, ListFiles, Upload, RefreshToken
 */

// ============================================================================
// GOOGLE DRIVE AUTH
// ============================================================================

/**
 * @deprecated Use unified OAuth flow instead: POST /api/oauth/start
 * This legacy endpoint will be removed after frontend migration.
 */
export const DocumentGoogleDriveAuthBodySchema = z.object({
  code: z.string(),
  redirectUri: z.string()
});

/**
 * @deprecated Use unified OAuth flow instead
 */
export const DocumentGoogleDriveAuthResponseSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string()
});

// ============================================================================
// LIST GOOGLE DRIVE FILES
// ============================================================================

/**
 * CLEAN ARCHITECTURE: Now uses connectionId instead of accessToken
 * OAuth connection handles token management automatically
 */
export const DocumentListGoogleDriveFilesParamsSchema = z.object({
  connectionId: z.string().uuid(), // ✅ Clean architecture - no more tokens!
  folderId: z.string().optional(),
  pageToken: z.string().optional()
});

export const DocumentListGoogleDriveFilesResponseSchema = z.object({
  files: z.array(
    z.object({
      id: z.string(),
      name: z.string(),
      mimeType: z.string(),
      parents: z.array(z.string()).optional(),
      webViewLink: z.string().optional(),
      thumbnailLink: z.string().optional()
    })
  ),
  nextPageToken: z.string().optional(),
  currentFolder: z.string()
});

// ============================================================================
// UPLOAD GOOGLE DRIVE
// ============================================================================

/**
 * CLEAN ARCHITECTURE: Now uses connectionId instead of accessToken/refreshToken
 * OAuth connection handles token management automatically
 */
export const DocumentUploadGoogleDriveBodySchema = z.object({
  connectionId: z.string().uuid(), // ✅ Clean architecture - no more tokens!
  fileIds: z.array(z.string()),
  parentId: z.string().optional(),
  displayName: z.string().optional()
  // refreshToken REMOVED - OAuth adapter handles refresh automatically
});

export const DocumentUploadGoogleDriveResponseSchema = z.union([
  DocumentResponseSchema,
  z.object({
    message: z.string(),
    documents: z.array(DocumentResponseSchema)
  })
]);

// ============================================================================
// REFRESH GOOGLE DRIVE TOKEN
// ============================================================================

/**
 * @deprecated OAuth adapter handles token refresh automatically
 * This endpoint is no longer needed with clean architecture.
 */
export const DocumentRefreshGoogleDriveTokenBodySchema = z.object({
  refreshToken: z.string()
});

/**
 * @deprecated OAuth adapter handles token refresh automatically
 */
export const DocumentRefreshGoogleDriveTokenResponseSchema = z.object({
  accessToken: z.string(),
  refreshToken: z.string()
});
